import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';
import { get } from 'ol/proj';
import { featureToGeoJSONObject } from './featureToGeoJSONObject';
export const sridToEpsgString = (srid) => srid.replace(/^SRID=/, 'EPSG:');
export const epsgToSridString = (srid) => srid.replace(/^EPSG:/, 'SRID=');
export const parseEWKT = (ewkt) => {
    const wktGeom = ewkt.split(';');
    const epsg = sridToEpsgString(wktGeom[0]);
    return { epsg, geometry: wktGeom[1] };
};
export const isValidEWKT = (ewkt) => {
    if (!(typeof ewkt == 'string')) {
        return false;
    }
    try {
        const wkt = new WKT();
        const { epsg: dataProjection, geometry } = parseEWKT(ewkt);
        wkt.readFeature(geometry, { dataProjection });
        return true;
    }
    catch (e) {
        return false;
    }
};
export const EWKTToGeoJSONObject = (ewkt, projection) => {
    try {
        const wkt = new WKT();
        const { epsg: dataProjection, geometry: wktGeom } = parseEWKT(ewkt);
        const olFeature = wkt.readFeature(wktGeom, { dataProjection });
        olFeature.set('__targetCRS', dataProjection);
        if (projection && projection !== dataProjection) {
            try {
                const reprojectedGeometry = olFeature.getGeometry()?.transform(dataProjection, projection);
                olFeature.setGeometry(reprojectedGeometry);
            }
            catch (err) {
                console.error(`[coordination transform]: ${dataProjection} => ${projection} - possible corrupted coordinates.`);
            }
        }
        return featureToGeoJSONObject(olFeature);
    }
    catch (error) {
        throw new Error(`Cannot convert EWKT "${ewkt}" to GeoJSONFeature (projection: ${projection})`, {
            cause: error,
        });
    }
};
const getNumberOfSignificantDigit = (projectionLike) => {
    const projection = get(projectionLike);
    const metersPerUnit = projection?.getMetersPerUnit();
    return 3 + Math.round(Math.log10(metersPerUnit ?? 1));
};
export const GeoJSONToEWKT = (geoJSONFeature, sourceProjection, destinationProjection, onlySignificantDigits = false) => {
    const geoJSON = new GeoJSON();
    const wkt = new WKT();
    const readFeature = geoJSON.readFeature(geoJSONFeature);
    // TODO - muze nastat pripad ze bude multiple geometries? - Array? - momentalne [0]!
    const olFeature = Array.isArray(readFeature) ? readFeature[0] : readFeature;
    if (!destinationProjection) {
        destinationProjection = geoJSONFeature.properties?.__targetCRS ?? sourceProjection;
    }
    if (sourceProjection !== destinationProjection) {
        try {
            const reprojectedGeometry = olFeature
                .getGeometry()
                ?.transform(sourceProjection, destinationProjection);
            olFeature.setGeometry(reprojectedGeometry);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            console.error(message);
            throw new Error(`[GeoJSONToEWKT] Cannot transform from ${sourceProjection} to ${destinationProjection}`);
        }
    }
    const decimals = onlySignificantDigits
        ? getNumberOfSignificantDigit(destinationProjection)
        : undefined;
    const wktFeature = wkt.writeFeature(olFeature, { decimals });
    const ewktProjection = epsgToSridString(destinationProjection.toString());
    return `${ewktProjection};${wktFeature}`;
};
export const unifyEWKT = (ewkt, onlySignificantDigits = false) => {
    try {
        const { epsg } = parseEWKT(ewkt);
        const geoJSONFeature = EWKTToGeoJSONObject(ewkt, epsg);
        return GeoJSONToEWKT(geoJSONFeature, epsg, epsg, onlySignificantDigits);
    }
    catch {
        return ewkt;
    }
};
//# sourceMappingURL=ewkt.js.map